<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["UstDonemId", "BirimId", "DonemId", "Sorgulama"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],
   
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
    BirimId(){
      this.Get();
    }
  },

  methods: {



    Get() {
      this.bugun = new Date();
      //alert(this.bugun);
      this.TabloVerileri = [];
      this.TabloDetayVerileri = [];


      let Filter = "&Donemid=" + this.DonemId + "&Birimid=" + this.BirimId + "&Ustdonemid=" + this.UstDonemId;
      console.log(Filter)

      this.ActionsFilterGet({ Service: "StrRaporlama/GetHedefGerceklesmeTablosu", Page: this.Page, Filter: Filter }).then((res) => {
          this.TabloVerileri = res.Data;
  
          this.Page.PageDataSize = res.TotalCount;

      });

    },

        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.HedefGerceklesmeTablosu;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
   
        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Birim Gösterge Tablosu',
                  'Birim Gösterge Tablosu',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>


   

  
    <div ref="HedefGerceklesmeTablosu" class="table-responsive">

      <div v-for="(TabloDetay, index) in TabloVerileri" :key="index">

      <table >
      
        <tbody>
          <tr><td>

           <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
            <tbody> 
              <tr>
            <td style="background-color:#25CCF7; font-weight: bold;width: 130px;" scope="col">{{ $t("HedefGerceklesmeTablosu.Table.TabloAdi") }}</td>
            <td colspan="8">{{ TabloDetay.BirimAdi }}</td>
          </tr>
          <tr>
            <td style="background-color:#25CCF7; font-weight: bold;" scope="col">{{ $t("HedefGerceklesmeTablosu.Table.Sorumlubirim") }}</td>
            <td colspan="8">{{ TabloDetay.SorumluBirimAdi }}</td>
          </tr>
  
          <tr>
            <td style="background-color:#25CCF7; font-weight: bold;" scope="col">{{ $t("HedefGerceklesmeTablosu.Table.Notu") }}</td>
            <td colspan="8">{{ TabloDetay.Not }}</td>
          </tr>
 
          </tbody>
          </table>

          </td></tr>
          <tr>
            <td>

              <div class="table-responsive">
   
               <table style="border: 1px solid; border-collapse: collapse;" border="1" class="table  table-md table-bordered border-success mb-0">
                 <tbody>
                   <tr>
                  <td style="width: 130px;background-color:#25CCF7; font-weight: bold; vertical-align: top;" :rowspan="TabloDetay.Detay.length+1">Detay</td>
                   <th style="background-color:#58B19F;text-align:center;"> Tablo Adı </th>
                   <th style="background-color:#58B19F;text-align:center;"> Tipi </th>
                   <th style="background-color:#58B19F;text-align:center;"> Gösterge </th>
                   <th style="background-color:#58B19F;text-align:center;"> Hedefe Etkisi </th>
                   <th style="background-color:#58B19F;text-align:center;"> Başlangıç Değeri </th>
                   <th style="background-color:#58B19F;text-align:center;"> Hedeflenen Değer </th>
                   <th style="background-color:#58B19F;text-align:center;"> Gerçekleşen Değer </th>
                   <th style="background-color:#58B19F;text-align:center;"> Hedef Sapma Oranı(%) </th>
                   </tr>
                    <tr v-for="(veriler, index) in TabloDetay.Detay" :key="index">
                      
                      <td>{{veriler.TabloAdi}}</td>
                      <td>{{veriler.GostergeTipi}}</td>
                      <td>{{veriler.PerformanGostergesi}}</td>
                      <td style="text-align:right;">{{veriler.HedefEtkisi}}</td>
                      <td style="text-align:right;">{{veriler.BaslangicDegeri}}</td>
                      <td style="text-align:right;">{{veriler.HedeflenenDeger}}</td>
                      <td style="text-align:right;">{{veriler.GerceklesenDeger}}</td>
                      <td style="text-align:right;">{{veriler.Sapmaorani}}</td>


                   </tr>
                 </tbody> 
             
               </table>

              </div>

            </td>
          </tr>
        </tbody>
      </table>
     </div>

      <br />
    </div>
  </div>
</template>
